import { OptionTypeBase } from 'react-select';

export const workloadTypeOptions: OptionTypeBase[] = [
  { id: 1, label: 'Presencial' },
  { id: 2, label: 'Híbrido' },
  { id: 3, label: 'Remoto' },
];
